import { Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "action-button-component",
  templateUrl: "./action-button.component.html",
  imports: [MatIconModule],
  styles: [
    `
      .dng-button {
        background-color: #97002e;
        border-color: #97002e;
      }
      .small-icon {
        font-size: 20px;
      }
    `,
  ],
})
export class ActionButtonComponent {
  value: any;
  @Input() buttonText: string;
  @Input() element: any;
  @Input() danger: boolean = false;
  @Input() classes: string = "";
  @Input() icon: string = "";
  @Input() label: string = "";
  @Input() actionFrom: (arg?: any) => void;
  @Input() disabled: boolean = false;

  buttonOnClick() {
    if (this.actionFrom) {
      try {
        if (this.element !== undefined) {
          this.actionFrom(this.element);
        } else {
          this.actionFrom();
        }
      } catch (e) {
        // swallow callback errors to avoid breaking UI
        console.error(e);
      }
    }
  }
}
